import { HashRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import Header from './components/Header';
import Home from './components/Home';
import Chroma from './components/Chroma';
import CrossPort from './components/CrossPort';
import Contact from './components/Contact';
import Privacy from './components/Privacy';
import Terms from './components/Terms';
import { NewsList, NewsPost } from './components/News';
import ThreeBackground from './components/ThreeBackground';

// The Chroma and CrossPort pages bring their own background and navigation;
// every other route sits on the particle field under the shared header.
function Shell() {
  const { pathname } = useLocation();
  const standalone = pathname.startsWith('/chroma') || pathname.startsWith('/crossport');
  return (
    <>
      {!standalone && <ThreeBackground />}
      {!standalone && <Header />}
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/chroma" element={<Chroma />} />
        <Route path="/crossport" element={<CrossPort />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/privacy" element={<Privacy />} />
        <Route path="/terms" element={<Terms />} />
        <Route path="/news" element={<NewsList />} />
        <Route path="/news/:slug" element={<NewsPost />} />
      </Routes>
    </>
  );
}

function App() {
  return (
    <Router>
      <Shell />
    </Router>
  );
}

export default App;
